"use strict";

exports.__esModule = true;
exports.isVNode = isVNode;
var _util = require("../../lib/utils/util");
function isVNode(node) {
  return node !== null && typeof node === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
}
;